export const getLowestDatasetOrderInStack = (datasets) => {
  // given an array of datasets where a dataset has the following structure:
  // {
  //   data: (5) [null, null, null, null, 2],
  //   fill: false,
  //   label: "Gender O: Empty",
  //   order: 0,
  //   stack: "Gender O"
  // }
  // in each dataset, only one of the data points is non-null
  // for each combination of stack name and non-null data point index,
  // return the index of the dataset with the lowest order 
  // return an object where the keys are the index of the lowest order dataset
  // and the values are true
  let lowestOrderInStack = {}
  datasets.forEach((dataset, datasetIndex) => {
    dataset.data.forEach((dataPoint, dataIndex) => {
      if (dataPoint !== null) {
        let key = `${dataset.stack}-${dataIndex}`
        if (!(key in lowestOrderInStack)) {
          lowestOrderInStack[key] = { order: dataset.order, index: datasetIndex }
        } else {
          if (dataset.order < lowestOrderInStack[key].order) {
            lowestOrderInStack[key] = { order: dataset.order, index: datasetIndex }
          }
        }
      }
    })
  })
  let result = {}
  Object.values(lowestOrderInStack).forEach((value) => {
    result[value.index] = true
  })
  return result
}

export const patterns = [
  'diagonal',
  'dot',
  'weave',
  'diamond',
  'zigzag',
  'ring',
  'plus',
  'dot-dash',
  'cross',
  'dash',
  'cross-dash',
  'triangle',
  'disc',
  'line',
  'zigzag-vertical',
  'diagonal-right-left',
  'square',
  'box',
  'triangle-inverted',
  'diamond-box',
  'line-vertical',
]

export const getStackPattern = (stack, stacks) => {
  // if stacks does not contain the stack, add it to the end of the array
  if (!stacks.includes(stack)) {
    stacks.push(stack);
  }
  return patterns[stacks.indexOf(stack) % patterns.length];
}

export const configureGroupStackDataLabels = (_this, chart) => {
  chart.getChartObject().options.plugins.datalabels.color = (context) => {
    return "#666";
  };
  chart.getChartObject().options.plugins.datalabels.anchor = "start";
  chart.getChartObject().options.plugins.datalabels.align = "start";
  chart.getChartObject().options.plugins.datalabels.offset = -2;
  chart.getChartObject().options.plugins.datalabels.formatter = (value, context) => {
    let datasets = context.chart.data.datasets
    if (_this.lowestOrderInStack === undefined) {
      _this.lowestOrderInStack = getLowestDatasetOrderInStack(datasets)
    }
    if (_this.lowestOrderInStack[context.datasetIndex] === true) {
      return datasets[context.datasetIndex].stack;
    } else {
      return ''
    }
  }
}

export const configureDataLabels = (_this, chart) => {
  chart.getChartObject().options.plugins.datalabels.color = (context) => {
    return context.dataset.backgroundColor;
  };
  chart.getChartObject().options.plugins.datalabels.anchor = "end";
  chart.getChartObject().options.plugins.datalabels.align = "end";
  chart.getChartObject().options.plugins.datalabels.offset = -4;
  chart.getChartObject().options.plugins.datalabels.display = (context) => {
    return context.dataset.data[context.dataIndex] > 0;
  }
  chart.getChartObject().options.plugins.datalabels.formatter = (_value, context) => {
      const data = context.chart.data;
      const { datasetIndex, dataIndex } = context;
      return `${data.calculatedData[datasetIndex][dataIndex]}% (${data.originalData[datasetIndex][dataIndex]})`;
  }
}

export const clickToOpenURL = (chart, native, _linkTarget) => { 
  if (native.length > 0) {
    let url = chart.dataSource[native[0].datasetIndex].url
    _linkTarget.href = url
    _linkTarget.click()
    chart.getChartObject().resize()
  }
}